import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'A collection of products or services that are offered by an institution, such as Attain Partners, to their customers.',
    name: 'Offerings',
    partialId: PartialId.Standard.create('offerings'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
